'use strict';

var React = require('react');

var SvgBillingStatementYenMajor = function SvgBillingStatementYenMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M7.436 5.506a.75.75 0 0 1 1.058-.07l1.506 1.317 1.506-1.317a.75.75 0 0 1 .988 1.128l-1.744 1.526v.41h1.25a.75.75 0 0 1 0 1.5h-1.25v.5h1.25a.75.75 0 0 1 0 1.5h-1.25v.5a.75.75 0 0 1-1.5 0v-.5h-1.25a.75.75 0 0 1 0-1.5h1.25v-.5h-1.25a.75.75 0 1 1 0-1.5h1.25v-.41l-1.744-1.526a.75.75 0 0 1-.07-1.058Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4 16a1.5 1.5 0 0 0 2.615 1.003l1.135-1.26 1.135 1.26a1.5 1.5 0 0 0 2.23 0l1.135-1.26 1.135 1.26a1.5 1.5 0 0 0 2.615-1.003v-11a2.5 2.5 0 0 0-2.5-2.5h-7a2.5 2.5 0 0 0-2.5 2.5v11Zm8.149-2h.203a.995.995 0 0 1 .641.326l1.507 1.674v-11a1 1 0 0 0-1-1h-7a1 1 0 0 0-1 1v11l1.507-1.674a.995.995 0 0 1 .641-.326h.204a.995.995 0 0 1 .641.326l1.507 1.674 1.507-1.674a.995.995 0 0 1 .642-.326Z"
  }));
};
SvgBillingStatementYenMajor.displayName = "BillingStatementYenMajor";

exports.SvgBillingStatementYenMajor = SvgBillingStatementYenMajor;
